import React from 'react';
import {
	Table,
	message,
	Popconfirm,
	Button,
	Icon,
	Input,
	Select,
	Form,
	Modal,
	Row,
	Col,
	Tooltip,
	Tag,
	Pagination,
	Typography,
	Divider,
	Statistic, Avatar
} from 'antd';
import { derClientRecommendAc as Ac } from '../../../redux/actions';
import { connect } from 'react-redux';
import moment from 'moment';
import ModalRender from './ModalRender';
import ModalRecommendRender from './ModalRecommend';
import SearchRender from './SearchRender';
import {server} from "../../../config/serverConfig";

const { Text } = Typography;
function RenderBase({ appRd, story, set, create, get, update, recommend }) {


	//导入本组件所需参数变量
	const { data, dataLoading, dataFetchProps, selectedRows, selectedRowKeys, modalVisible, modalType, selectedRow, selectedRowIndex, pagination, searchProps, modalRecommendVisible } = story;
	const { loginData, screenType, loginUserRoleAuth } = appRd;
	const { roleid, groupid, user_name } = loginData;

	//dataFetchProps
	if (dataLoading) {
		//全局尽量统一通过修改dataLoading来刷新数据，以减少数据不准一。
		// 加载loading
		get({ ...dataFetchProps, ...searchProps });

	}

	//刷新按钮强制刷新，需要提示
	const refreshData = async () => {
		let msg = await get({ ...dataFetchProps, ...searchProps });
		message.info(msg);
	}



	//定义表头
	const columns = [{
		title: 'id',
		dataIndex: 'id',
		key: 'id',
		className: 'align_center', width: 50
	}, {
		title: '客户名称',
		dataIndex: 'enterprise_name',
		width: 180,
		key: 'enterprise_name',
		render: (text, record) => (
			<div>
				<Tag color="#2db7f5">{text}</Tag>
			</div>
		),
	}, {
		title: 'SAP编码',
		dataIndex: 'sap_no', width: 100,
		key: 'sap_no',
	}, {
		title: '社会信用代码',
		dataIndex: 'social_credit_code',
		key: 'social_credit_code',
		className: 'align_center', width: 180,
	}, {
		title: '分公司',
		dataIndex: 'subcompany',
		key: 'subcompany',
		className: 'align_center', width: 180,
	},	{
		title: '业务员',
		dataIndex: 'bizperson',
		key: 'bizperson',
		render: (text) => (
			<div>
				{text ? (
					<span>
               <Avatar size="small" style={{ marginRight: 8, backgroundColor: '#69c0ff', color: '#fff' }}>
  {text.charAt(0)}
</Avatar>
              <Statistic value={text} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />
            </span>
				) : (
					''
				)}
			</div>
		),
		width: 80,
	}
		, {
		title: '状态',
		dataIndex: 'status', width: 80,
		key: 'status'

	}, /*{
		title: '担保额度',
		dataIndex: 'deposit_quota',
		key: 'deposit_quota', width: 180,
		render: text => <Statistic value={text / 100} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />,
	},*/ {
		title: '申请额度',
		dataIndex: 'apply_quota',
		key: 'apply_quota', width: 180,
		render: text => <Statistic value={text / 100} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />,
	}, {
		title: '预授信额度',
		dataIndex: 'pre_credit_quota',
		key: 'pre_credit_quota', width: 180,
		render: text => <Statistic value={text / 100} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />,
	},{
			title: '最新一次额度时间',
			dataIndex: 'm_derClientCredit',
			key: 'client_credit',
			width: 180,
			render: (m_derClientCredit, record) => {
				// 获取对象值的数组
				const creditArray = Object.values(m_derClientCredit);

				// 初始化变量以存储最晚时间和对应记录
				let latestTime = 0;
				let latestRecord = null;

				// 遍历 creditArray 找到 guarantee_type 为 0 的记录中最晚的时间
				for (const item of creditArray) {
					if (item.guarantee_type === 2) {
						const currentAuditTime = new Date(item.audit_time).getTime();
						if (currentAuditTime > latestTime) {
							latestTime = currentAuditTime;
							latestRecord = item;
						}
					}
				}

				// 检查是否找到符合条件的记录
				if (latestRecord) {
					const time = moment(latestTime).format("YYYY-MM-DD HH:mm");
					return (
						<div>
							{time}
						</div>
					);
				} else {
					return null; // 如果没有符合条件的记录，返回 null 或其他你希望显示的内容
				}
			},
		}


	];


	const rowSelection = {
		selectedRowKeys,
		selectedRows,
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			if (selected) {
				set({ selectedRowKeys: [record.id], selectedRow: record, selectedRows: [record] })
			} else { set({ selectedRowKeys: [], selectedRow: {}, selectedRows: [] }) }
		},
		//onChange: (selectedRowKeys, selectedRows) => { SET({selectedRowKeys, selectedRows}) }
	};



	const BtnHandle = async (e) => {
		if (e.target.name === 'create') {
			set({ modalVisible: true, modalType: 'create' });
		}
		if (e.target.name === 'update') {
			set({ modalVisible: true, modalType: 'update' });
		}
		if (e.target.name === 'push') {
			set({ modalRecommendVisible: true, modalType: 'update' });
		}

	}

	const formRenderProps = {
		onFinish(data) {
			// 1  先清空分页中原有的当前页，pagination.current =1
			// 2 将搜索内容更新到 searchProps内。
			// 3 更新dataLoading 为true。

			let paginationNew = { ...pagination }
			paginationNew.current = 1;

			set({ dataLoading: true, pagination: { ...paginationNew }, searchProps: data });
		}

	}
	pagination.onChange = (page, pageSize) => {
		if (isNaN(pageSize)) {
			//这是异常刷新，不记录任何值,比如排序刷新
			return;
		}
		let paginationNew = { ...pagination };
		paginationNew.current = page;  //如果page是1，直接提交即可
		paginationNew.pageSize = pageSize;
		set({ pagination: paginationNew, dataLoading: true });

	}

	pagination.onShowSizeChange = (current, size) => {
		let paginationNew = { ...pagination };
		let overcount = paginationNew.pageSize * (paginationNew.current - 1);

		paginationNew.current = 1 + parseInt(overcount / size);

		paginationNew.pageSize = size;
		set({ pagination: paginationNew, dataLoading: true });

	}
	const tableDefinition = {
		rowKey: 'id',
		loading: dataLoading,
		pagination: pagination,
		size: 'small',
		columns: columns,
		dataSource: data,
		//expandedRowRender: record => <p style={{ margin: 0}}>{JSON.stringify(record,['user_id','mobile','email','roleid','groupid','subgroup','mail_user_rule','mail_grp_rule'])}</p>,
		//rowSelection: rowSelection,
		onRow: (record, index) => { return { onClick: event => set({ selectedRow: record, selectedRowIndex: index }) } },
		rowClassName: (record, index) => index === selectedRowIndex ? 'selectedItem' : '',
		scroll: { x: 800, y: window.innerHeight - 370 },
	}

	const modalRenderProps = {

		item: modalType === 'create' ? {} : selectedRow,
		type: modalType,
		visible: modalVisible,
		onOk(data) {
			set({ modalVisible: false })
			if (modalType === 'create') {
				data.status = '待批准'
				create(data).then(res => {
					message.info(res);
				})
			}

			if (modalType === 'update') {
				update(data, selectedRowIndex).then(res => {
					return message.info(res);

				});

			}


		},
		onCancel() {
			set({ modalVisible: false })
		},
	}

	const modalRecommendProps = {

		item: selectedRow,
		type: modalType,
		visible: modalRecommendVisible,
		async onOk(data) {
			data.status = '同意';
			set({ modalRecommendVisible: false });
			update(data, selectedRowIndex);

			//推送给银行，调esb接口
			await recommend({ id: data.id, enterpriseName: data.enterprise_name, socialCreditCode: data.social_credit_code, depositQuota: data.deposit_quota, applyQuota: data.apply_quota, sap_no: data.sap_no }).then(d => { set({ dataLoading: true }); return message.loading(d, 20) });

		},
		onReject(data) {

			set({ modalRecommendVisible: false })
			update({ status: '拒绝' }, selectedRowIndex).then(res => message.info(res));
		},
		onCancel() {
			set({ modalRecommendVisible: false })
		},
	}


	const ModalRenderGene = () => <ModalRender {...modalRenderProps} />;
	const ModalRecommendGene = () => <ModalRecommendRender {...modalRecommendProps} />;


	return (
		<div>
			<Row style={{ marginBottom: 10 }}>
				<Col span={24}><Input.Group compact size="large">
					<Button onClick={refreshData}  > <Icon type="sync" style={{ color: 'green' }} />刷新</Button>
					<Button onClick={BtnHandle} name='create' hidden={loginUserRoleAuth.indexOf('/derClient/recommend/btn001') == -1}> <Icon type="plus" />新客</Button>
					<Button onClick={BtnHandle} name='update' disabled={selectedRowIndex === -1} hidden={loginUserRoleAuth.indexOf('/derClient/recommend/btn002') == -1}> <Icon type="edit" />修改</Button>
					<Divider type={"vertical"} />
					{/*<Button onClick={BtnHandle} name='push'  disabled={selectedRow.status!=='待批准'}> <Icon type="check" />推荐</Button>*/}
					<Button onClick={BtnHandle} name='push' > <Icon type="check" />推荐</Button>

				</Input.Group>

				</Col>

			</Row>
			<Row>
				<Col span={24}>
					<SearchRender {...formRenderProps} />
				</Col>
			</Row>
			<Table className='logListTable' {...tableDefinition} />
			{modalVisible && <ModalRenderGene />}
			{modalRecommendVisible && <ModalRecommendGene />}



		</div>);


}

const mapStateToProps = (state) => {
	return {
		story: state.derClientRecommendRd,
		appRd: state.appReducer
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		set: (value) => dispatch(Ac.SET(value)),
		get: (value) => dispatch(Ac.GET(value)),
		create: (value) => dispatch(Ac.CREATE(value)),
		update: (value, index) => dispatch(Ac.UPDATE(value, index)),
		recommend: (value) => dispatch(Ac.RECOMMEND(value)),

	}
}

const derClientRecommend = connect(mapStateToProps, mapDispatchToProps)(RenderBase);

export default derClientRecommend;
